import React, { useState, useRef } from 'react'

import Logo from './newComponents/Logo'
import useCart from 'store/CartProvider'
import Phone from 'components/Icons/landingPhone'
import SearchInput from './newComponents/SearchInput'
import HeaderActions from './newComponents/HeaderActions'
import CallRequestForm from './newComponents/CallRequestForm'
import { useWishlistContext } from '../../store/WishlistContext'

const Header = () => {
  const [isCartOpen, setIsCartOpen] = useState(false)
  const [isWishlistOpen, setIsWishlistOpen] = useState(false)

  const cartRef = useRef(null)
  const wishlistRef = useRef(null)

  const { products } = useCart()
  const { wishlistProducts } = useWishlistContext()

  const handleWishlistToggle = () => {
    setIsWishlistOpen(prev => !prev)
    setIsCartOpen(false)
  }

  const handleCartToggle = () => {
    setIsCartOpen(prev => !prev)
    setIsWishlistOpen(false)
  }

  const commonActionsProps = {
    wishlistRef,
    cartRef,
    wishlistCount: wishlistProducts.length,
    cartCount: products.length,
    isWishlistOpen,
    isCartOpen,
    onWishlistToggle: handleWishlistToggle,
    onCartToggle: handleCartToggle,
    onWishlistClose: () => setIsWishlistOpen(false),
    onCartClose: () => setIsCartOpen(false),
  }

  return (
    <div className="border-b border-slate-200 md:py-3 fixed top-0 left-0 right-0 z-[100] bg-white">
      <div className="hidden md:flex items-center container justify-between gap-6">
        <Logo />
        <SearchInput />

        <div className="flex flex-col relative group">
          <div className="flex flex-col cursor-pointer">
            <p className="text-[13px] text-slate-600 mb-1">
              შეკვეთა 10:00-21:00
            </p>
            <a
              href="tel:0322423500"
              className="font-semibold text-red-500 flex justify-between items-center text-base"
            >
              <Phone
                height="16"
                width="16"
                fill="#ef4444"
                className="mb-[2px]"
              />
              <span>0 322 423 500</span>
            </a>
          </div>

          <CallRequestForm />
        </div>

        <HeaderActions {...commonActionsProps} />
      </div>

      <div className="md:hidden px-2 py-3">
        <div className="flex items-center justify-between gap-3">
          <Logo isMobile />
          <SearchInput isMobile />
          <HeaderActions {...commonActionsProps} isMobile />
        </div>
      </div>
    </div>
  )
}

export default Header
